'use client';

import { FC } from 'react';
import { GeoPopupView } from 'organisms/GeoPopup/GeoPopupView';
import { useGeoPopup } from './hooks';

export const GeoPopup: FC = () => {
  const geoParams = useGeoPopup();

  return (
    <GeoPopupView
      open={geoParams.show}
      onClose={geoParams?.action}
      url={geoParams?.redirectUrl || ''}
      countryCode={geoParams?.countryCode}
    />
  );
};
